export const PAYMENT_TYPE = {
    online: "online",
    cod: "cod",
};
